const PROGRAMS = [
  {
    tag: "Program 01",
    title: "Wire Termination & Crimping",
    icon: "ri-plug-2-line",
    duration: "4 Weeks",
    description:
      "Master every wire you'll touch in the field — Cat5e/6/6a, coax, fiber, security cabling and low-voltage runs. Terminate, crimp, and test to industry standards.",
    skills: ["RJ45 & keystone jacks", "Coax F-connectors", "Fiber splicing basics", "Cable certification"],
    image:
      "https://readdy.ai/api/search-image?query=Close%20up%20photograph%20of%20hands%20crimping%20a%20clear%20RJ45%20connector%20onto%20blue%20Cat6%20network%20cable%20on%20a%20wooden%20workbench%2C%20precision%20crimping%20tool%20in%20focus%2C%20colorful%20network%20cables%20coiled%20nearby%2C%20cable%20tester%20with%20orange%20LED%20lights%20glowing%2C%20warm%20workshop%20lighting%20with%20soft%20shadows%2C%20highly%20detailed%20realistic%20texture%2C%20trade%20school%20training%20environment%2C%20editorial%20photography%20aesthetic&width=800&height=600&seq=techy-program-wire-01&orientation=landscape",
  },
  {
    tag: "Program 02",
    title: "Networks & IT Foundations",
    icon: "ri-router-line",
    duration: "5 Weeks",
    description:
      "Build, configure, and troubleshoot real networks. Switches, routers, VLANs, WiFi, and the CompTIA Network+ skill set that hiring companies expect.",
    skills: ["Switch & router setup", "VLAN & subnetting", "WiFi survey & install", "Network+ prep"],
    image:
      "https://readdy.ai/api/search-image?query=Professional%20server%20rack%20with%20neatly%20organized%20colorful%20patch%20cables%20being%20connected%20by%20a%20technician%2C%20blinking%20orange%20and%20amber%20status%20LEDs%2C%20network%20switch%20panel%20in%20focus%2C%20dark%20server%20room%20background%20with%20subtle%20warm%20accent%20lighting%2C%20cable%20management%20labels%20visible%2C%20crisp%20detailed%20macro%20photography%2C%20industrial%20trade%20school%20setting&width=800&height=600&seq=techy-program-network-02&orientation=landscape",
  },
  {
    tag: "Program 03",
    title: "Security & Access Control",
    icon: "ri-shield-check-line",
    duration: "4 Weeks",
    description:
      "Install and service surveillance cameras, DVRs/NVRs, badge readers, keypads, and door strikes. Learn what property managers and integrators actually need.",
    skills: ["IP & analog CCTV", "Access control wiring", "DVR/NVR config", "Site walk-throughs"],
    image:
      "https://readdy.ai/api/search-image?query=Technician%20mounting%20a%20black%20dome%20security%20camera%20on%20a%20commercial%20ceiling%2C%20drill%20and%20mounting%20tools%20in%20focus%2C%20warm%20interior%20lighting%2C%20wired%20network%20cable%20visible%2C%20clean%20professional%20installation%2C%20trade%20school%20practical%20training%20photograph%2C%20crisp%20detail%2C%20soft%20orange%20accent%20lighting%2C%20editorial%20photography%20aesthetic&width=800&height=600&seq=techy-program-security-03&orientation=landscape",
  },
  {
    tag: "Program 04",
    title: "Fire Alarm Systems",
    icon: "ri-fire-line",
    duration: "5 Weeks",
    description:
      "Life-safety systems from panel to pull station. Understand NFPA 72, addressable vs conventional systems, and how to pass real inspections.",
    skills: ["Panel programming", "Detector placement", "NFPA 72 basics", "Testing & inspection"],
    image:
      "https://readdy.ai/api/search-image?query=Red%20fire%20alarm%20panel%20mounted%20on%20a%20clean%20industrial%20wall%20with%20technician%20hands%20programming%20it%20using%20a%20laptop%2C%20smoke%20detectors%20and%20pull%20stations%20visible%2C%20warm%20amber%20workshop%20lighting%2C%20detailed%20cables%20running%20to%20the%20panel%2C%20trade%20school%20life%20safety%20training%20scene%2C%20crisp%20realistic%20photography%2C%20soft%20shadows%2C%20industrial%20aesthetic&width=800&height=600&seq=techy-program-fire-04&orientation=landscape",
  },
  {
    tag: "Program 05",
    title: "Computers & Hardware Repair",
    icon: "ri-computer-line",
    duration: "3 Weeks",
    description:
      "Diagnose, repair, and deploy desktops, laptops, and workstations. Windows, imaging, and the daily hardware issues field techs actually run into.",
    skills: ["Component swap", "OS install & imaging", "Peripheral troubleshoot", "A+ fundamentals"],
    image:
      "https://readdy.ai/api/search-image?query=Open%20desktop%20computer%20on%20a%20workshop%20bench%20with%20technician%20hands%20installing%20a%20memory%20module%2C%20motherboard%20and%20fans%20clearly%20visible%2C%20precision%20screwdriver%20set%20laid%20out%2C%20warm%20workshop%20lighting%20with%20orange%20accents%2C%20laptop%20in%20background%20showing%20diagnostic%20software%2C%20detailed%20realistic%20macro%20photography%2C%20trade%20school%20environment&width=800&height=600&seq=techy-program-computer-05&orientation=landscape",
  },
  {
    tag: "Program 06",
    title: "Overall Tech Fluency",
    icon: "ri-lightbulb-flash-line",
    duration: "Woven throughout",
    description:
      "Being 'tech savvy' is a skill. We build the habits — diagnostic thinking, ticketing, customer conversations, and how to keep learning on the job.",
    skills: ["Diagnostic mindset", "Ticket & documentation", "Client communication", "Career coaching"],
    image:
      "https://readdy.ai/api/search-image?query=Group%20of%20trade%20school%20students%20wearing%20casual%20workwear%20around%20a%20workbench%20studying%20a%20laptop%20screen%20together%2C%20cables%20and%20tools%20on%20the%20table%2C%20instructor%20pointing%20at%20screen%2C%20warm%20workshop%20lighting%20with%20soft%20orange%20accents%2C%20diverse%20students%2C%20focused%20expressions%2C%20candid%20editorial%20photography%2C%20highly%20detailed%20realistic%20texture&width=800&height=600&seq=techy-program-fluency-06&orientation=landscape",
  },
];

export default function Programs() {
  return (
    <section id="programs" className="relative bg-background-50 py-20 md:py-28">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-3xl mb-12 md:mb-16">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-800 text-xs font-mono uppercase tracking-[0.2em] mb-4">
            <i className="ri-graduation-cap-line"></i> Programs
          </div>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-[1.05]">
            Every skill on the truck.
            <br />
            <span className="text-primary-600">None of the filler.</span>
          </h2>
          <p className="mt-5 text-base md:text-lg text-foreground-700 max-w-2xl">
            Our curriculum is built with hiring managers from the low-voltage, IT, and life-safety
            trades. If it's not something a working technician does every week, it's not in here.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {PROGRAMS.map((p) => (
            <article
              key={p.title}
              className="group relative flex flex-col rounded-xl overflow-hidden bg-background-50 border border-background-200 hover:border-primary-400 transition-colors"
            >
              <div className="relative h-48 md:h-52 overflow-hidden bg-background-200">
                <img
                  src={p.image}
                  alt={p.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3 inline-flex items-center gap-2 px-2.5 py-1 rounded-md bg-background-50/95 text-foreground-900 text-[11px] font-mono uppercase tracking-widest">
                  {p.tag}
                </div>
                <div className="absolute bottom-3 right-3 inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-primary-500 text-background-50 text-xs font-semibold">
                  <i className="ri-time-line"></i> {p.duration}
                </div>
              </div>
              <div className="p-5 md:p-6 flex flex-col flex-1">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-100 text-primary-700">
                    <i className={`${p.icon} text-lg`} aria-hidden="true"></i>
                  </div>
                  <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground-950">
                    {p.title}
                  </h3>
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed">{p.description}</p>
                <ul className="mt-4 space-y-1.5">
                  {p.skills.map((s) => (
                    <li key={s} className="flex items-start gap-2 text-sm text-foreground-800">
                      <i className="ri-checkbox-circle-fill text-primary-500 mt-0.5" aria-hidden="true"></i>
                      <span>{s}</span>
                    </li>
                  ))}
                </ul>
                <a
                  href="#apply"
                  className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600 hover:text-primary-700 cursor-pointer whitespace-nowrap"
                >
                  Enroll in this track
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}